import PrimaryButton from "../designSystem/buttons/PrimaryButton";
import PrimaryButtonSmall from "../designSystem/buttons/PrimaryButtonSmall";
import SecondaryButton from "../designSystem/buttons/SecondaryButton";
import SecondaryButtonSmall from "../designSystem/buttons/SecondaryButtonSmall";
import TextButton from "../designSystem/buttons/TextButton";
import SeeMoreButton from "../designSystem/buttons/SeeMoreButton";
import Hero from "../designSystem/Hero";
import { Helmet } from "react-helmet-async";
import TertiaryButton from "../designSystem/buttons/TertiaryButton";
import Accordion from "../designSystem/Accordion";
import HeroImage from "../../assets/images/headerillustration.png";
import { ReactComponent as OneIcon } from "../../assets/icons/1.svg";
import { ReactComponent as TwoIcon } from "../../assets/icons/2.svg";
import { ReactComponent as ThreeIcon } from "../../assets/icons/3.svg";
import WhyChooseUsBG from "../../assets/images/whyChooseUsBg.png";
import WhyChooseUs from "../../assets/images/whyChooseUs1.jpg";
import Cards from "../designSystem/cards/Cards";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import "../../css/App.css";

const LandingPage = () => {
    const location = useLocation();

    useEffect(() => {
      if (!location.hash) return;

      const sectionId = location.hash.replace("#", "");

      setTimeout(() => {
        const section = document.getElementById(sectionId);

        if (section) {
          section.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      }, 100);
    }, [location]);
  return (
    <div>
      <Helmet>
        <title>DUO FINANCIAL</title>
        <meta
          name="description"
          content="Duo Financial is a trading style of Contractor Financial Limited is an Appointed Representative of Rosemount Financial Solutions (IFA) Ltd which is authorised and regulated by the Financial Conduct Authority. Rosemount Financial Solutions (IFA) Ltd is entered on the Financial Services Register under reference 535515. 
Contractor Financial Limited is registered in England and Wales (Company Number: 15401629). Registered Address: John White Community Centre, Grange Avenue, Coventry, West Midlands, England, CV3 2ED. The information on this website is subject to the UK regulatory regime and is intended for consumers in the UK."
        />
      </Helmet>
      {/* <Hero
              title={`Financial Clarity
      Direction & Confidence`}
              subtitle="Wealth Management Solutions"
      backgroundImage={HeroBackground}
      titleAlign="left"
      subtitleAlign="left"
      ></Hero> */}
      <div className="background-container  bottom-right-radius bg-gray-2 ">
        <div className="content-container">
          <div className="row gap-xl grid2 align-center">
            <div className="column gap-xl align-left justify-center">
              <div className="content-semibold secondary uppercase align-left">
                DUO FINANCIAL
              </div>
              <h1 className="primary">
                Your Trusted Mortgage & Protection Advisers
              </h1>
              <div className="content text-primary-1">
                Mortgages and protection can feel overwhelming. There’s a lot of
                information to take in, important decisions to make, and plenty
                of unfamiliar terminology along the way.
              </div>
              <div className="content-semibold text-primary-1">
                At Duo Financial, we're here to make the process clearer and
                more straightforward. Whether you're buying your first home,
                moving to a bigger property, remortgaging, or looking to protect
                your family’s future, we'll guide you every step of the way with
                honest advice and genuine support.
              </div>
            </div>
            <img src={HeroImage} alt="Hero" className="hero-image" />
          </div>
        </div>
      </div>
      <div className="content-container" id="about-us">
        <div className="column align-center gap-xl">
          <div className="content-semibold text-gray-1">ABOUT US</div>
          <h2 className=" text-gray-1">
            Created by real people, for real life
          </h2>
          <div className="content text-gray-1">
            Duo Financial was founded by Jo Elwell and Billie Davoile with a
            simple goal: to create a welcoming, supportive space where people
            can get expert mortgage and protection advice without feeling
            overwhelmed.
            <br />
            We believe no question is a silly question. We take the time to
            understand your situation, explain your options clearly, and help
            you make informed decisions with confidence.
          </div>
          <TertiaryButton
            // onClick={() => navigate("/contact-us")}
            onClick={() =>
              window.open(
                "https://calendly.com/contractor-financial/duo-financial-mortgage-enquiry",
                "_blank",
              )
            }
            text="BOOK AN APPOINTMENT"
          />
        </div>
      </div>
      <div className="background-container  bg-gray-2 " id="how-we-can-help">
        <div className="content-container">
          <div className="column gap-l align-center">
            <div className="content-semibold text-primary-1">
              HOW WE CAN HELP
            </div>
            <div className="service-cards-row">
              <Cards
                title="Mortgages"
                description="Whether you're a first-time buyer, home mover, landlord, or looking to remortgage, we'll help you understand your options, work out what you can afford, and find a mortgage that suits your circumstances."
                icon={<OneIcon />}
              />
              <Cards
                title="Protection"
                description="Life doesn't always go to plan. We can help you put the right protection in place to safeguard your home, income, and loved ones should the unexpected happen."
                icon={<TwoIcon />}
              />
              <Cards
                title="Straightforward Advice"
                description="We believe financial advice should be easy to understand. That's why we explain everything in plain English, avoid unnecessary jargon, and work at a pace that suits you."
                icon={<ThreeIcon />}
              />
            </div>
          </div>
        </div>
      </div>
      {/* <div className="background-container bg-gray-2 "
      >
        <img
          src={WhyChooseUsBG}
          alt="Why Choose Us Background"
          className="choose-us-bg"
        />

        <div className="content-container">
          <div className="row gap-xl grid2 align-center">
            <div className="column gap-xl align-left justify-center">
              <div className="content-semibold secondary uppercase align-left">
                DUO FINANCIAL
              </div>
              <h1 className="primary">
                Your Trusted Mortgage & Protection Advisers
              </h1>
              <div className="content text-primary-1">
                Mortgages and protection can feel overwhelming. There’s a lot of
                information to take in, important decisions to make, and plenty
                of unfamiliar terminology along the way.
              </div>
              <div className="content-semibold text-primary-1">
                At Duo Financial, we're here to make the process clearer and
                more straightforward. Whether you're buying your first home,
                moving to a bigger property, remortgaging, or looking to protect
                your family’s future, we'll guide you every step of the way with
                honest advice and genuine support.
              </div>
            </div>
            <img src={HeroImage} alt="Hero" className="hero-image" />
          </div>
        </div>
      </div> */}
      <div
        className="background-container bg-gray-2 why-choose-section"
        id="why-choose-us"
      >
        <img
          src={WhyChooseUsBG}
          alt=""
          aria-hidden="true"
          className="choose-us-bg"
        />

        <div className="content-container why-choose-content">
          <div className="row gap-xl grid2 align-center">
            <img
              src={WhyChooseUs}
              alt="Hero"
              className="hero-image all-radius-xl"
            />
            <div className="column gap-xl align-left justify-center">
              <div className="content-semibold text-gray-2 uppercase align-left">
                WHY CHOOSE US
              </div>

              <h2 className="text-gray-2">Why Choose Duo Financial?</h2>
              <ul>
                <li className="subtitle text-gray-2">
                  Friendly, approachable advice
                </li>
                <li className="subtitle text-gray-2">
                  Clear explanations without the jargon
                </li>
                <li className="subtitle text-gray-2">
                  Support throughout the entire process
                </li>
                <li className="subtitle text-gray-2">
                  Honest recommendations tailored to you
                </li>
                <li className="subtitle text-gray-2">
                  A team that genuinely cares about your goals
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="background-container bg-gray-2  bottom-left-radius">
        <div className="content-container">
          <div className="column gap-xl align-center">
            <h2 className="text-primary-1">For every stage of your journey</h2>
            <div className="text-primary-1 content">
              From first homes to forever homes, and everything in between,
              we're here to help you take your next step with confidence.
              Whether you're just starting to explore your options or you're
              ready to move forward, we'll provide the guidance and support you
              need to make informed decisions about your future.
            </div>
          </div>
        </div>
      </div>
      <div className="content-container">
        <div className="content text-gray-1 align-center">
          Your home may be repossessed if you do not keep up repayments on your
          mortgage.
        </div>
      </div>
    </div>
  );
};

export default LandingPage;

{
  /* <div className="page-container">
  <PrimaryButton text="Primary Button" />
  <PrimaryButtonSmall text="Primary Button Small" />
  <SecondaryButton text="Secondary Button" />
  <SecondaryButtonSmall text="Secondary Button Small" />
  <TextButton text="Text Button" />
  <SeeMoreButton text="See More" />
  <TertiaryButton text="Tertiary Button" />
  <Accordion
    title="Accordion Title"
    children={
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
    }
  />
</div> */
}